// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.14.0 (commit 3ac273e970212dd613e57f4c312c49a9ab8ccb50).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AgentCreateInsightReducer from "./agent_create_insight_reducer";
import AgentHighlightElementReducer from "./agent_highlight_element_reducer";
import AgentNavigateToTwinReducer from "./agent_navigate_to_twin_reducer";
import AssociateTwinReducer from "./associate_twin_reducer";
import ClearAllDataReducer from "./clear_all_data_reducer";
import CloseSessionReducer from "./close_session_reducer";
import CmdClearSelectionReducer from "./cmd_clear_selection_reducer";
import CmdFlyAlongPathReducer from "./cmd_fly_along_path_reducer";
import CmdFlyAndLookAtReducer from "./cmd_fly_and_look_at_reducer";
import CmdFlyToLocationReducer from "./cmd_fly_to_location_reducer";
import CmdFlyToTwinReducer from "./cmd_fly_to_twin_reducer";
import CmdFollowTwinReducer from "./cmd_follow_twin_reducer";
import CmdHideRelationshipsReducer from "./cmd_hide_relationships_reducer";
import CmdHighlightGeoReducer from "./cmd_highlight_geo_reducer";
import CmdHighlightTwinReducer from "./cmd_highlight_twin_reducer";
import CmdLookAtLocationReducer from "./cmd_look_at_location_reducer";
import CmdLookAtTwinReducer from "./cmd_look_at_twin_reducer";
import CmdOrbitTwinReducer from "./cmd_orbit_twin_reducer";
import CmdSelectTwinsReducer from "./cmd_select_twins_reducer";
import CmdSetCameraModeReducer from "./cmd_set_camera_mode_reducer";
import CmdSetTransparencyReducer from "./cmd_set_transparency_reducer";
import CmdShowRelationshipsReducer from "./cmd_show_relationships_reducer";
import CmdShowTwinInfoReducer from "./cmd_show_twin_info_reducer";
import CmdStopCameraReducer from "./cmd_stop_camera_reducer";
import CreateAnnotationReducer from "./create_annotation_reducer";
import CreateHighlightReducer from "./create_highlight_reducer";
import CreateSessionReducer from "./create_session_reducer";
import DebugEmitChatAudioReducer from "./debug_emit_chat_audio_reducer";
import DeleteAnnotationReducer from "./delete_annotation_reducer";
import DeleteChatMessageReducer from "./delete_chat_message_reducer";
import DisassociateTwinReducer from "./disassociate_twin_reducer";
import EditChatMessageReducer from "./edit_chat_message_reducer";
import EmitChatAudioReducer from "./emit_chat_audio_reducer";
import EnterSessionReducer from "./enter_session_reducer";
import GrantUserTokenReducer from "./grant_user_token_reducer";
import HeartbeatReducer from "./heartbeat_reducer";
import HideWebCursorReducer from "./hide_web_cursor_reducer";
import InitReducer from "./init_reducer";
import JoinScopeForReducer from "./join_scope_for_reducer";
import LeaveScopeForReducer from "./leave_scope_for_reducer";
import LeaveSessionReducer from "./leave_session_reducer";
import LeaveSessionScopeReducer from "./leave_session_scope_reducer";
import PurgeAgentPresencesReducer from "./purge_agent_presences_reducer";
import RegisterOrgAdminServiceReducer from "./register_org_admin_service_reducer";
import RegisterPresenceReducer from "./register_presence_reducer";
import RegisterTtsCacheBlobReducer from "./register_tts_cache_blob_reducer";
import RemoveOrgModuleUserReducer from "./remove_org_module_user_reducer";
import RequestUserTokenReducer from "./request_user_token_reducer";
import ResolveAnnotationReducer from "./resolve_annotation_reducer";
import SendAgentChatMessageReducer from "./send_agent_chat_message_reducer";
import SendChatMessageReducer from "./send_chat_message_reducer";
import SendDirectMessageReducer from "./send_direct_message_reducer";
import SetInfraBrokerConfigReducer from "./set_infra_broker_config_reducer";
import SetManagedSessionServicesReducer from "./set_managed_session_services_reducer";
import SetMpDispatchConfigReducer from "./set_mp_dispatch_config_reducer";
import SetOrgModuleUserRoleReducer from "./set_org_module_user_role_reducer";
import SetRetiredServicesReducer from "./set_retired_services_reducer";
import SetUserTokenRelayServicesReducer from "./set_user_token_relay_services_reducer";
import SetWorkosOrgIdReducer from "./set_workos_org_id_reducer";
import TouchTtsCacheEntryReducer from "./touch_tts_cache_entry_reducer";
import TransferOrgAdminServiceReducer from "./transfer_org_admin_service_reducer";
import TransferWorkosOrgIdReducer from "./transfer_workos_org_id_reducer";
import UnresolveAnnotationReducer from "./unresolve_annotation_reducer";
import UpdateAnnotationContentReducer from "./update_annotation_content_reducer";
import UpdateAnnotationVisibilityReducer from "./update_annotation_visibility_reducer";
import UpdateAvatarStateReducer from "./update_avatar_state_reducer";
import UpdateAvatarTransformReducer from "./update_avatar_transform_reducer";
import UpdateDisplayNameReducer from "./update_display_name_reducer";
import UpdateFocusedTwinReducer from "./update_focused_twin_reducer";
import UpdatePresenceStatusReducer from "./update_presence_status_reducer";
import UpdateSelectedTwinsReducer from "./update_selected_twins_reducer";
import UpdateWebCursorReducer from "./update_web_cursor_reducer";
import UpdateWebCursorHoverReducer from "./update_web_cursor_hover_reducer";
import UpdateWebCursorScreenReducer from "./update_web_cursor_screen_reducer";
import UpdateWebGraphViewReducer from "./update_web_graph_view_reducer";
import UpdateWebNavigationReducer from "./update_web_navigation_reducer";
import UpdateWebTelemetryViewReducer from "./update_web_telemetry_view_reducer";

// Import all procedure arg schemas
import * as AddManagedSessionParticipantProcedure from "./add_managed_session_participant_procedure";
import * as AddManagedSessionParticipantWithRoleProcedure from "./add_managed_session_participant_with_role_procedure";
import * as ChatHistoryProcedure from "./chat_history_procedure";
import * as CloseManagedSessionProcedure from "./close_managed_session_procedure";
import * as CreateManagedSessionProcedure from "./create_managed_session_procedure";
import * as GetTtsDownloadUrlProcedure from "./get_tts_download_url_procedure";
import * as GetTtsUploadUrlProcedure from "./get_tts_upload_url_procedure";
import * as RemoveManagedSessionParticipantProcedure from "./remove_managed_session_participant_procedure";
import * as ReplaceManagedSessionParticipantProcedure from "./replace_managed_session_participant_procedure";

// Import all table schema definitions
import ChatAudioEventRow from "./chat_audio_event_table";
import DiscoverableSessionsRow from "./discoverable_sessions_table";
import MyAnnotationsRow from "./my_annotations_table";
import MyAvatarStatesRow from "./my_avatar_states_table";
import MyChatMessagesRow from "./my_chat_messages_table";
import MyHighlightStatesRow from "./my_highlight_states_table";
import MyPlayerFocusesRow from "./my_player_focuses_table";
import MySessionCameraPosesRow from "./my_session_camera_poses_table";
import MySessionParticipantsRow from "./my_session_participants_table";
import MySessionsRow from "./my_sessions_table";
import MyUserTokenGrantsRow from "./my_user_token_grants_table";
import MyWebCursorStatesRow from "./my_web_cursor_states_table";
import OrgModuleUserRow from "./org_module_user_table";
import PlayerCommandEventRow from "./player_command_event_table";
import PresenceClientRow from "./presence_client_table";
import PresenceStateRow from "./presence_state_table";
import TtsCacheRow from "./tts_cache_table";
import UserTokenRequestEventRow from "./user_token_request_event_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  chatAudioEvent: __table({
    name: 'chat_audio_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, ChatAudioEventRow),
  orgModuleUser: __table({
    name: 'org_module_user',
    indexes: [
      { accessor: 'identity', name: 'org_module_user_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'org_module_user_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, OrgModuleUserRow),
  playerCommandEvent: __table({
    name: 'player_command_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, PlayerCommandEventRow),
  presenceClient: __table({
    name: 'presence_client',
    indexes: [
      { accessor: 'connection_id', name: 'presence_client_connection_id_idx_btree', algorithm: 'btree', columns: [
        'connectionId',
      ] },
      { accessor: 'presence_id', name: 'presence_client_presence_id_idx_btree', algorithm: 'btree', columns: [
        'presenceId',
      ] },
    ],
    constraints: [
      { name: 'presence_client_connection_id_key', constraint: 'unique', columns: ['connectionId'] },
    ],
  }, PresenceClientRow),
  presenceState: __table({
    name: 'presence_state',
    indexes: [
      { accessor: 'associated_twin_id', name: 'presence_state_associated_twin_id_idx_btree', algorithm: 'btree', columns: [
        'associatedTwinId',
      ] },
      { accessor: 'presence_id', name: 'presence_state_presence_id_idx_btree', algorithm: 'btree', columns: [
        'presenceId',
      ] },
      { accessor: 'user_identity', name: 'presence_state_user_identity_idx_btree', algorithm: 'btree', columns: [
        'userIdentity',
      ] },
    ],
    constraints: [
      { name: 'presence_state_presence_id_key', constraint: 'unique', columns: ['presenceId'] },
      { name: 'presence_state_user_identity_key', constraint: 'unique', columns: ['userIdentity'] },
    ],
  }, PresenceStateRow),
  ttsCache: __table({
    name: 'tts_cache',
    indexes: [
      { accessor: 'cache_key', name: 'tts_cache_cache_key_idx_btree', algorithm: 'btree', columns: [
        'cacheKey',
      ] },
      { accessor: 'last_used_at', name: 'tts_cache_last_used_at_idx_btree', algorithm: 'btree', columns: [
        'lastUsedAt',
      ] },
    ],
    constraints: [
      { name: 'tts_cache_cache_key_key', constraint: 'unique', columns: ['cacheKey'] },
    ],
  }, TtsCacheRow),
  userTokenRequestEvent: __table({
    name: 'user_token_request_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, UserTokenRequestEventRow),
  discoverableSessions: __table({
    name: 'discoverable_sessions',
    indexes: [
    ],
    constraints: [
    ],
  }, DiscoverableSessionsRow),
  myAnnotations: __table({
    name: 'my_annotations',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAnnotationsRow),
  myAvatarStates: __table({
    name: 'my_avatar_states',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAvatarStatesRow),
  myChatMessages: __table({
    name: 'my_chat_messages',
    indexes: [
    ],
    constraints: [
    ],
  }, MyChatMessagesRow),
  myHighlightStates: __table({
    name: 'my_highlight_states',
    indexes: [
    ],
    constraints: [
    ],
  }, MyHighlightStatesRow),
  myPlayerFocuses: __table({
    name: 'my_player_focuses',
    indexes: [
    ],
    constraints: [
    ],
  }, MyPlayerFocusesRow),
  mySessionCameraPoses: __table({
    name: 'my_session_camera_poses',
    indexes: [
    ],
    constraints: [
    ],
  }, MySessionCameraPosesRow),
  mySessionParticipants: __table({
    name: 'my_session_participants',
    indexes: [
    ],
    constraints: [
    ],
  }, MySessionParticipantsRow),
  mySessions: __table({
    name: 'my_sessions',
    indexes: [
    ],
    constraints: [
    ],
  }, MySessionsRow),
  myUserTokenGrants: __table({
    name: 'my_user_token_grants',
    indexes: [
    ],
    constraints: [
    ],
  }, MyUserTokenGrantsRow),
  myWebCursorStates: __table({
    name: 'my_web_cursor_states',
    indexes: [
    ],
    constraints: [
    ],
  }, MyWebCursorStatesRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("agent_create_insight", AgentCreateInsightReducer),
  __reducerSchema("agent_highlight_element", AgentHighlightElementReducer),
  __reducerSchema("agent_navigate_to_twin", AgentNavigateToTwinReducer),
  __reducerSchema("associate_twin", AssociateTwinReducer),
  __reducerSchema("clear_all_data", ClearAllDataReducer),
  __reducerSchema("close_session", CloseSessionReducer),
  __reducerSchema("cmd_clear_selection", CmdClearSelectionReducer),
  __reducerSchema("cmd_fly_along_path", CmdFlyAlongPathReducer),
  __reducerSchema("cmd_fly_and_look_at", CmdFlyAndLookAtReducer),
  __reducerSchema("cmd_fly_to_location", CmdFlyToLocationReducer),
  __reducerSchema("cmd_fly_to_twin", CmdFlyToTwinReducer),
  __reducerSchema("cmd_follow_twin", CmdFollowTwinReducer),
  __reducerSchema("cmd_hide_relationships", CmdHideRelationshipsReducer),
  __reducerSchema("cmd_highlight_geo", CmdHighlightGeoReducer),
  __reducerSchema("cmd_highlight_twin", CmdHighlightTwinReducer),
  __reducerSchema("cmd_look_at_location", CmdLookAtLocationReducer),
  __reducerSchema("cmd_look_at_twin", CmdLookAtTwinReducer),
  __reducerSchema("cmd_orbit_twin", CmdOrbitTwinReducer),
  __reducerSchema("cmd_select_twins", CmdSelectTwinsReducer),
  __reducerSchema("cmd_set_camera_mode", CmdSetCameraModeReducer),
  __reducerSchema("cmd_set_transparency", CmdSetTransparencyReducer),
  __reducerSchema("cmd_show_relationships", CmdShowRelationshipsReducer),
  __reducerSchema("cmd_show_twin_info", CmdShowTwinInfoReducer),
  __reducerSchema("cmd_stop_camera", CmdStopCameraReducer),
  __reducerSchema("create_annotation", CreateAnnotationReducer),
  __reducerSchema("create_highlight", CreateHighlightReducer),
  __reducerSchema("create_session", CreateSessionReducer),
  __reducerSchema("debug_emit_chat_audio", DebugEmitChatAudioReducer),
  __reducerSchema("delete_annotation", DeleteAnnotationReducer),
  __reducerSchema("delete_chat_message", DeleteChatMessageReducer),
  __reducerSchema("disassociate_twin", DisassociateTwinReducer),
  __reducerSchema("edit_chat_message", EditChatMessageReducer),
  __reducerSchema("emit_chat_audio", EmitChatAudioReducer),
  __reducerSchema("enter_session", EnterSessionReducer),
  __reducerSchema("grant_user_token", GrantUserTokenReducer),
  __reducerSchema("heartbeat", HeartbeatReducer),
  __reducerSchema("hide_web_cursor", HideWebCursorReducer),
  __reducerSchema("init", InitReducer),
  __reducerSchema("join_scope_for", JoinScopeForReducer),
  __reducerSchema("leave_scope_for", LeaveScopeForReducer),
  __reducerSchema("leave_session", LeaveSessionReducer),
  __reducerSchema("leave_session_scope", LeaveSessionScopeReducer),
  __reducerSchema("purge_agent_presences", PurgeAgentPresencesReducer),
  __reducerSchema("register_org_admin_service", RegisterOrgAdminServiceReducer),
  __reducerSchema("register_presence", RegisterPresenceReducer),
  __reducerSchema("register_tts_cache_blob", RegisterTtsCacheBlobReducer),
  __reducerSchema("remove_org_module_user", RemoveOrgModuleUserReducer),
  __reducerSchema("request_user_token", RequestUserTokenReducer),
  __reducerSchema("resolve_annotation", ResolveAnnotationReducer),
  __reducerSchema("send_agent_chat_message", SendAgentChatMessageReducer),
  __reducerSchema("send_chat_message", SendChatMessageReducer),
  __reducerSchema("send_direct_message", SendDirectMessageReducer),
  __reducerSchema("set_infra_broker_config", SetInfraBrokerConfigReducer),
  __reducerSchema("set_managed_session_services", SetManagedSessionServicesReducer),
  __reducerSchema("set_mp_dispatch_config", SetMpDispatchConfigReducer),
  __reducerSchema("set_org_module_user_role", SetOrgModuleUserRoleReducer),
  __reducerSchema("set_retired_services", SetRetiredServicesReducer),
  __reducerSchema("set_user_token_relay_services", SetUserTokenRelayServicesReducer),
  __reducerSchema("set_workos_org_id", SetWorkosOrgIdReducer),
  __reducerSchema("touch_tts_cache_entry", TouchTtsCacheEntryReducer),
  __reducerSchema("transfer_org_admin_service", TransferOrgAdminServiceReducer),
  __reducerSchema("transfer_workos_org_id", TransferWorkosOrgIdReducer),
  __reducerSchema("unresolve_annotation", UnresolveAnnotationReducer),
  __reducerSchema("update_annotation_content", UpdateAnnotationContentReducer),
  __reducerSchema("update_annotation_visibility", UpdateAnnotationVisibilityReducer),
  __reducerSchema("update_avatar_state", UpdateAvatarStateReducer),
  __reducerSchema("update_avatar_transform", UpdateAvatarTransformReducer),
  __reducerSchema("update_display_name", UpdateDisplayNameReducer),
  __reducerSchema("update_focused_twin", UpdateFocusedTwinReducer),
  __reducerSchema("update_presence_status", UpdatePresenceStatusReducer),
  __reducerSchema("update_selected_twins", UpdateSelectedTwinsReducer),
  __reducerSchema("update_web_cursor", UpdateWebCursorReducer),
  __reducerSchema("update_web_cursor_hover", UpdateWebCursorHoverReducer),
  __reducerSchema("update_web_cursor_screen", UpdateWebCursorScreenReducer),
  __reducerSchema("update_web_graph_view", UpdateWebGraphViewReducer),
  __reducerSchema("update_web_navigation", UpdateWebNavigationReducer),
  __reducerSchema("update_web_telemetry_view", UpdateWebTelemetryViewReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
  __procedureSchema("add_managed_session_participant", AddManagedSessionParticipantProcedure.params, AddManagedSessionParticipantProcedure.returnType),
  __procedureSchema("add_managed_session_participant_with_role", AddManagedSessionParticipantWithRoleProcedure.params, AddManagedSessionParticipantWithRoleProcedure.returnType),
  __procedureSchema("chat_history", ChatHistoryProcedure.params, ChatHistoryProcedure.returnType),
  __procedureSchema("close_managed_session", CloseManagedSessionProcedure.params, CloseManagedSessionProcedure.returnType),
  __procedureSchema("create_managed_session", CreateManagedSessionProcedure.params, CreateManagedSessionProcedure.returnType),
  __procedureSchema("get_tts_download_url", GetTtsDownloadUrlProcedure.params, GetTtsDownloadUrlProcedure.returnType),
  __procedureSchema("get_tts_upload_url", GetTtsUploadUrlProcedure.params, GetTtsUploadUrlProcedure.returnType),
  __procedureSchema("remove_managed_session_participant", RemoveManagedSessionParticipantProcedure.params, RemoveManagedSessionParticipantProcedure.returnType),
  __procedureSchema("replace_managed_session_participant", ReplaceManagedSessionParticipantProcedure.params, ReplaceManagedSessionParticipantProcedure.returnType),
);

type __SchemaWithTableAccessorAliases = Omit<typeof tablesSchema.schemaType, "tables"> & {
  tables: typeof tablesSchema.schemaType.tables & {
    /** @deprecated Use `chatAudioEvent` instead. This alias will be removed in the next major version. */
    readonly "chat_audio_event": Omit<typeof tablesSchema.schemaType.tables["chatAudioEvent"], "accessorName"> & { readonly accessorName: "chat_audio_event" };
    /** @deprecated Use `orgModuleUser` instead. This alias will be removed in the next major version. */
    readonly "org_module_user": Omit<typeof tablesSchema.schemaType.tables["orgModuleUser"], "accessorName"> & { readonly accessorName: "org_module_user" };
    /** @deprecated Use `playerCommandEvent` instead. This alias will be removed in the next major version. */
    readonly "player_command_event": Omit<typeof tablesSchema.schemaType.tables["playerCommandEvent"], "accessorName"> & { readonly accessorName: "player_command_event" };
    /** @deprecated Use `presenceClient` instead. This alias will be removed in the next major version. */
    readonly "presence_client": Omit<typeof tablesSchema.schemaType.tables["presenceClient"], "accessorName"> & { readonly accessorName: "presence_client" };
    /** @deprecated Use `presenceState` instead. This alias will be removed in the next major version. */
    readonly "presence_state": Omit<typeof tablesSchema.schemaType.tables["presenceState"], "accessorName"> & { readonly accessorName: "presence_state" };
    /** @deprecated Use `ttsCache` instead. This alias will be removed in the next major version. */
    readonly "tts_cache": Omit<typeof tablesSchema.schemaType.tables["ttsCache"], "accessorName"> & { readonly accessorName: "tts_cache" };
    /** @deprecated Use `userTokenRequestEvent` instead. This alias will be removed in the next major version. */
    readonly "user_token_request_event": Omit<typeof tablesSchema.schemaType.tables["userTokenRequestEvent"], "accessorName"> & { readonly accessorName: "user_token_request_event" };
    /** @deprecated Use `discoverableSessions` instead. This alias will be removed in the next major version. */
    readonly "discoverable_sessions": Omit<typeof tablesSchema.schemaType.tables["discoverableSessions"], "accessorName"> & { readonly accessorName: "discoverable_sessions" };
    /** @deprecated Use `myAnnotations` instead. This alias will be removed in the next major version. */
    readonly "my_annotations": Omit<typeof tablesSchema.schemaType.tables["myAnnotations"], "accessorName"> & { readonly accessorName: "my_annotations" };
    /** @deprecated Use `myAvatarStates` instead. This alias will be removed in the next major version. */
    readonly "my_avatar_states": Omit<typeof tablesSchema.schemaType.tables["myAvatarStates"], "accessorName"> & { readonly accessorName: "my_avatar_states" };
    /** @deprecated Use `myChatMessages` instead. This alias will be removed in the next major version. */
    readonly "my_chat_messages": Omit<typeof tablesSchema.schemaType.tables["myChatMessages"], "accessorName"> & { readonly accessorName: "my_chat_messages" };
    /** @deprecated Use `myHighlightStates` instead. This alias will be removed in the next major version. */
    readonly "my_highlight_states": Omit<typeof tablesSchema.schemaType.tables["myHighlightStates"], "accessorName"> & { readonly accessorName: "my_highlight_states" };
    /** @deprecated Use `myPlayerFocuses` instead. This alias will be removed in the next major version. */
    readonly "my_player_focuses": Omit<typeof tablesSchema.schemaType.tables["myPlayerFocuses"], "accessorName"> & { readonly accessorName: "my_player_focuses" };
    /** @deprecated Use `mySessionCameraPoses` instead. This alias will be removed in the next major version. */
    readonly "my_session_camera_poses": Omit<typeof tablesSchema.schemaType.tables["mySessionCameraPoses"], "accessorName"> & { readonly accessorName: "my_session_camera_poses" };
    /** @deprecated Use `mySessionParticipants` instead. This alias will be removed in the next major version. */
    readonly "my_session_participants": Omit<typeof tablesSchema.schemaType.tables["mySessionParticipants"], "accessorName"> & { readonly accessorName: "my_session_participants" };
    /** @deprecated Use `mySessions` instead. This alias will be removed in the next major version. */
    readonly "my_sessions": Omit<typeof tablesSchema.schemaType.tables["mySessions"], "accessorName"> & { readonly accessorName: "my_sessions" };
    /** @deprecated Use `myUserTokenGrants` instead. This alias will be removed in the next major version. */
    readonly "my_user_token_grants": Omit<typeof tablesSchema.schemaType.tables["myUserTokenGrants"], "accessorName"> & { readonly accessorName: "my_user_token_grants" };
    /** @deprecated Use `myWebCursorStates` instead. This alias will be removed in the next major version. */
    readonly "my_web_cursor_states": Omit<typeof tablesSchema.schemaType.tables["myWebCursorStates"], "accessorName"> & { readonly accessorName: "my_web_cursor_states" };
  };
};

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.14.0" as const,
  },
  tables: tablesSchema.schemaType.tables as __SchemaWithTableAccessorAliases["tables"],
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  __SchemaWithTableAccessorAliases,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

const tableAccessorAliases = {
  "chat_audio_event": "chatAudioEvent",
  "org_module_user": "orgModuleUser",
  "player_command_event": "playerCommandEvent",
  "presence_client": "presenceClient",
  "presence_state": "presenceState",
  "tts_cache": "ttsCache",
  "user_token_request_event": "userTokenRequestEvent",
  "discoverable_sessions": "discoverableSessions",
  "my_annotations": "myAnnotations",
  "my_avatar_states": "myAvatarStates",
  "my_chat_messages": "myChatMessages",
  "my_highlight_states": "myHighlightStates",
  "my_player_focuses": "myPlayerFocuses",
  "my_session_camera_poses": "mySessionCameraPoses",
  "my_session_participants": "mySessionParticipants",
  "my_sessions": "mySessions",
  "my_user_token_grants": "myUserTokenGrants",
  "my_web_cursor_states": "myWebCursorStates",
} as const;

function __withTableAccessorAliases<T extends object>(target: T, freeze = false): T {
  const out = Object.create(Object.getPrototypeOf(target)) as T & Record<string, unknown>;
  Object.defineProperties(out, Object.getOwnPropertyDescriptors(target));
  for (const [deprecatedAccessor, targetAccessor] of Object.entries(tableAccessorAliases)) {
    if (deprecatedAccessor in out) {
      continue;
    }
    Object.defineProperty(out, deprecatedAccessor, {
      enumerable: true,
      configurable: false,
      get: () => out[targetAccessor],
    });
  }
  return freeze ? Object.freeze(out) : out;
}

type __DbViewBase = __DbConnectionImpl<typeof REMOTE_MODULE>["db"];
export type DbView = __DbViewBase & {
  /** @deprecated Use `chatAudioEvent` instead. This alias will be removed in the next major version. */
  readonly "chat_audio_event": __DbViewBase["chatAudioEvent"];
  /** @deprecated Use `orgModuleUser` instead. This alias will be removed in the next major version. */
  readonly "org_module_user": __DbViewBase["orgModuleUser"];
  /** @deprecated Use `playerCommandEvent` instead. This alias will be removed in the next major version. */
  readonly "player_command_event": __DbViewBase["playerCommandEvent"];
  /** @deprecated Use `presenceClient` instead. This alias will be removed in the next major version. */
  readonly "presence_client": __DbViewBase["presenceClient"];
  /** @deprecated Use `presenceState` instead. This alias will be removed in the next major version. */
  readonly "presence_state": __DbViewBase["presenceState"];
  /** @deprecated Use `ttsCache` instead. This alias will be removed in the next major version. */
  readonly "tts_cache": __DbViewBase["ttsCache"];
  /** @deprecated Use `userTokenRequestEvent` instead. This alias will be removed in the next major version. */
  readonly "user_token_request_event": __DbViewBase["userTokenRequestEvent"];
  /** @deprecated Use `discoverableSessions` instead. This alias will be removed in the next major version. */
  readonly "discoverable_sessions": __DbViewBase["discoverableSessions"];
  /** @deprecated Use `myAnnotations` instead. This alias will be removed in the next major version. */
  readonly "my_annotations": __DbViewBase["myAnnotations"];
  /** @deprecated Use `myAvatarStates` instead. This alias will be removed in the next major version. */
  readonly "my_avatar_states": __DbViewBase["myAvatarStates"];
  /** @deprecated Use `myChatMessages` instead. This alias will be removed in the next major version. */
  readonly "my_chat_messages": __DbViewBase["myChatMessages"];
  /** @deprecated Use `myHighlightStates` instead. This alias will be removed in the next major version. */
  readonly "my_highlight_states": __DbViewBase["myHighlightStates"];
  /** @deprecated Use `myPlayerFocuses` instead. This alias will be removed in the next major version. */
  readonly "my_player_focuses": __DbViewBase["myPlayerFocuses"];
  /** @deprecated Use `mySessionCameraPoses` instead. This alias will be removed in the next major version. */
  readonly "my_session_camera_poses": __DbViewBase["mySessionCameraPoses"];
  /** @deprecated Use `mySessionParticipants` instead. This alias will be removed in the next major version. */
  readonly "my_session_participants": __DbViewBase["mySessionParticipants"];
  /** @deprecated Use `mySessions` instead. This alias will be removed in the next major version. */
  readonly "my_sessions": __DbViewBase["mySessions"];
  /** @deprecated Use `myUserTokenGrants` instead. This alias will be removed in the next major version. */
  readonly "my_user_token_grants": __DbViewBase["myUserTokenGrants"];
  /** @deprecated Use `myWebCursorStates` instead. This alias will be removed in the next major version. */
  readonly "my_web_cursor_states": __DbViewBase["myWebCursorStates"];
};

type __TablesBase = __QueryBuilder<typeof tablesSchema.schemaType>;
export type Tables = __TablesBase & {
  /** @deprecated Use `chatAudioEvent` instead. This alias will be removed in the next major version. */
  readonly "chat_audio_event": __TablesBase["chatAudioEvent"];
  /** @deprecated Use `orgModuleUser` instead. This alias will be removed in the next major version. */
  readonly "org_module_user": __TablesBase["orgModuleUser"];
  /** @deprecated Use `playerCommandEvent` instead. This alias will be removed in the next major version. */
  readonly "player_command_event": __TablesBase["playerCommandEvent"];
  /** @deprecated Use `presenceClient` instead. This alias will be removed in the next major version. */
  readonly "presence_client": __TablesBase["presenceClient"];
  /** @deprecated Use `presenceState` instead. This alias will be removed in the next major version. */
  readonly "presence_state": __TablesBase["presenceState"];
  /** @deprecated Use `ttsCache` instead. This alias will be removed in the next major version. */
  readonly "tts_cache": __TablesBase["ttsCache"];
  /** @deprecated Use `userTokenRequestEvent` instead. This alias will be removed in the next major version. */
  readonly "user_token_request_event": __TablesBase["userTokenRequestEvent"];
  /** @deprecated Use `discoverableSessions` instead. This alias will be removed in the next major version. */
  readonly "discoverable_sessions": __TablesBase["discoverableSessions"];
  /** @deprecated Use `myAnnotations` instead. This alias will be removed in the next major version. */
  readonly "my_annotations": __TablesBase["myAnnotations"];
  /** @deprecated Use `myAvatarStates` instead. This alias will be removed in the next major version. */
  readonly "my_avatar_states": __TablesBase["myAvatarStates"];
  /** @deprecated Use `myChatMessages` instead. This alias will be removed in the next major version. */
  readonly "my_chat_messages": __TablesBase["myChatMessages"];
  /** @deprecated Use `myHighlightStates` instead. This alias will be removed in the next major version. */
  readonly "my_highlight_states": __TablesBase["myHighlightStates"];
  /** @deprecated Use `myPlayerFocuses` instead. This alias will be removed in the next major version. */
  readonly "my_player_focuses": __TablesBase["myPlayerFocuses"];
  /** @deprecated Use `mySessionCameraPoses` instead. This alias will be removed in the next major version. */
  readonly "my_session_camera_poses": __TablesBase["mySessionCameraPoses"];
  /** @deprecated Use `mySessionParticipants` instead. This alias will be removed in the next major version. */
  readonly "my_session_participants": __TablesBase["mySessionParticipants"];
  /** @deprecated Use `mySessions` instead. This alias will be removed in the next major version. */
  readonly "my_sessions": __TablesBase["mySessions"];
  /** @deprecated Use `myUserTokenGrants` instead. This alias will be removed in the next major version. */
  readonly "my_user_token_grants": __TablesBase["myUserTokenGrants"];
  /** @deprecated Use `myWebCursorStates` instead. This alias will be removed in the next major version. */
  readonly "my_web_cursor_states": __TablesBase["myWebCursorStates"];
};

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
const tablesBase: __TablesBase = __makeQueryBuilder(tablesSchema.schemaType);
export const tables: Tables = __withTableAccessorAliases(tablesBase, true) as Tables;

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = Omit<__EventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = Omit<__ReducerEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = Omit<__SubscriptionEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for error events. */
export type ErrorContext = Omit<__ErrorContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  declare db: DbView;

  constructor(config: __DbConnectionConfig<typeof REMOTE_MODULE>) {
    super(config);
    this.db = __withTableAccessorAliases(this.db) as DbView;
  }

  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

